import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

function WelcomePage() {
    const navigate = useNavigate();
    const [institutionName, setInstitutionName] = useState('');
    const [error, setError] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);

    // Helper function to check if typed letters match institution names
    const getInstitutionSuggestions = useCallback((input) => {
        const normalizedInput = input.toLowerCase().trim();
        const institutions = ['Catalyst'];

        if (!normalizedInput) {
            return [];
        }

        return institutions.filter(institution =>
            institution.toLowerCase().startsWith(normalizedInput)
        );
    }, []);

    // Helper function to handle input changes with suggestions
    const handleInputChange = useCallback((e) => {
        const value = e.target.value;
        setInstitutionName(value);
        setError('');

        const newSuggestions = getInstitutionSuggestions(value);
        setSuggestions(newSuggestions);
        setShowSuggestions(newSuggestions.length > 0 && value.length > 0);
    }, [getInstitutionSuggestions]);

    // Helper function to select a suggestion
    const selectSuggestion = useCallback((suggestion) => {
        setInstitutionName(suggestion);
        setSuggestions([]);
        setShowSuggestions(false);
    }, []);

    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        const value = (institutionName || '').trim();
        if (!value) {
            setError('Please enter your institution name');
            return;
        }
        // Normalize: remove spaces, lowercase. Adjust if you need different rules.
        const normalized = value.replace(/\s+/g, '-').toLowerCase();
        navigate(`/${normalized}`);
    }, [institutionName, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-white px-4">
            <div className="w-full max-w-md">
                <h1 className="text-2xl font-semibold text-gray-900 mb-6 text-center">Welcome to Pi-Schedule for Teachers</h1>
                <p className="text-gray-600 mb-6 text-center">Enter your institution name to continue</p>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div className="relative">
                        <label htmlFor="institution" className="block text-sm font-medium text-gray-700 mb-1">Institution name</label>
                        <input
                            id="institution"
                            type="text"
                            value={institutionName}
                            onChange={handleInputChange}
                            onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                            onFocus={() => {
                                if (suggestions.length > 0) {
                                    setShowSuggestions(true);
                                }
                            }}
                            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            autoFocus
                            autoComplete="off"
                        />
                        {showSuggestions && suggestions.length > 0 && (
                            <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg">
                                {suggestions.map((suggestion, index) => (
                                    <button
                                        key={index}
                                        type="button"
                                        onClick={() => selectSuggestion(suggestion)}
                                        className="w-full text-left px-3 py-2 hover:bg-gray-100 focus:bg-gray-100 focus:outline-none first:rounded-t-md last:rounded-b-md"
                                    >
                                        {suggestion}
                                    </button>
                                ))}
                            </div>
                        )}
                        {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
                    </div>
                    <button type="submit" className="w-full bg-blue-600 text-white rounded-md px-4 py-2 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500">Continue</button>
                </form>
            </div>
        </div>
    );
}

export default WelcomePage;


